/* 🤖 this file was generated by svg-to-ts */
export const siriusSignpostPictogram: {
  name: 'signpost_pictogram';
  data: string;
} = {
  name: 'signpost_pictogram',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.732 13.232A2.5 2.5 0 0 1 7.5 12.5h30.75a1 1 0 0 1 .743.331l6.75 7.5a1 1 0 0 1 0 1.338l-6.75 7.5a1 1 0 0 1-.743.331H7.5A2.5 2.5 0 0 1 5 27V15a2.5 2.5 0 0 1 .732-1.768ZM7.5 14.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h30.305l5.85-6.5-5.85-6.5H7.5Z" fill="currentColor"/></svg>`
};
